import React, { useState, useEffect, useRef } from 'react';
import { FixedSizeList as List } from 'react-window';
import { Layout, Space, Button, Card, InputNumber } from 'antd';
import getVWRank from './getVWRank';
import usePlayersCount from './helpers';
import axios from 'axios';
const { Header, Content, Footer } = Layout;
const sponsored = './img/sponsored.jpg';

const App = () => {
    const [players, setPlayers] = useState([]);
    const [offset, setOffset] = useState(1);
    const [totalPlayers, setTotalPlayers] = useState(7_100_000);
    const listRef = useRef();

    const getAllPlayersCount = usePlayersCount(setTotalPlayers);

    const loadPlayers = async (viaInput, num) => {
        const ids = joinIds(num, num + 1000);
        const response = await axios.post(
            'https://api.vimeworld.com/user/session',
            ids,
            {
                headers: {
                    'Content-Type': 'application/json',
                    'Access-Token': 'D0qbQnz5IOyciFCg9j8lOaokNC5ZAgE',
                },
            }
        );
        viaInput
            ? setPlayers(response.data)
            : setPlayers([...players, ...response.data]);
        listRef.current?.scrollToItem(players.length, 'smart');
    };

    useEffect(() => getAllPlayersCount(4, 7_100_000), []);

    function numberWithCommas(x) {
        return x.toString().replace(/\B(?=(\d{3})+(?!\d))/g, ',');
    }

    // https://api.vimeworld.ru/user/session
    // D0qbQnz5IOyciFCg9j8lOaokNC5ZAgE

    const joinIds = (o, lim) => {
        const ids = [];
        for (let i = o; i < lim; i++) ids.push(i);
        return ids;
    };

    const Row = ({ index, style }) => {
        const player = players[index];
        if (!player) return null;
        const head = `http://skin.vimeworld.ru/helm/${player?.username}.png`;
        const link = `https://vime.top/p/${player?.username}`;
        const isOnline = player?.online.value;
        return (
            <>
                <Card
                    className='player_card'
                    theme='dark'
                    style={{
                        ...style,
                        paddingBottom: index === offset + 998 ? 100 : 0,
                        top:
                            index === offset + 998 ? style.top + 20 : style.top,
                    }}>
                    <img
                        src={head}
                        style={{ borderRadius: 4, width: 20 }}
                        alt={player?.username + ' head'}
                    />
                    <Button
                        type='link'
                        target='_blank'
                        href={link}
                        style={{ color: getVWRank(player?.rank).color }}>
                        {player?.username}
                    </Button>
                    <span style={{ display: 'flex', alignItems: 'center' }}>
                        <span
                            className='online-status'
                            style={{
                                background: isOnline ? '#2cb978' : '#ee5a5a',
                                marginRight: 25,
                            }}></span>
                        ID: {player?.id}
                    </span>
                </Card>
                {players.length - 1 === index && (
                    <div className='load-more'>
                        <Button
                            onClick={async () => {
                                setOffset(offset + 1000);
                                loadPlayers(false, offset + 1000);
                            }}>
                            Загрузить еще
                        </Button>
                    </div>
                )}
            </>
        );
    };

    return (
        <Layout theme='dark' style={{ height: '100vh' }}>
            <Header
                style={{
                    color: 'white',
                    display: 'flex',
                    justifyContent: 'space-between',
                }}>
                <Space theme='dark' mode='horizontal'>
                    <Button
                        type='primary'
                        onClick={() => loadPlayers(true, offset)}>
                        Загрузить игроков
                    </Button>
                    <div>
                        <span style={{ margin: '0 10px' }}>Начать с ID:</span>
                        <InputNumber
                            min={1}
                            value={offset}
                            onChange={setOffset}
                            style={{ width: '200px' }}
                        />
                    </div>
                </Space>
                <Space>
                    <h3 style={{ color: 'white', margin: 0 }}>
                        Всего игроков на VimeWorld:{' '}
                        <span style={{ color: '#92FF8A' }}>
                            {numberWithCommas(totalPlayers)}
                        </span>
                    </h3>
                </Space>
            </Header>
            <Content
                style={{
                    display: 'flex',
                    flexDirection: 'column',
                    alignItems: 'center',
                }}>
                {players.length > 0 ? (
                    <List
                        className='players-list'
                        height={window.innerHeight}
                        itemCount={players.length}
                        itemSize={40}
                        ref={listRef}
                        itemKey={(index) => players[index].username}
                        width={500}>
                        {Row}
                    </List>
                ) : (
                    <div style={{ margin: '120px auto' }}>Not yet loaded.</div>
                )}
            </Content>
            <Footer
                style={{
                    display: 'flex',
                    justifyContent: 'space-between',
                    alignItems: 'center',
                    background: '#001529',
                    color: 'white',
                    padding: '5px 30px',
                }}>
                <h3 style={{ color: 'white', margin: 0 }}>
                    developed by:{' '}
                    <a
                        href='https://vime.top/p/COCU_COCUCKA'
                        target='_blank'
                        style={{ color: '#92FF8A' }}>
                        pPitohu
                    </a>{' '}
                    aka{' '}
                    <a
                        href='https://vime.top/p/COCU_COCUCKA'
                        target='_blank'
                        style={{ color: '#92FF8A' }}>
                        COCU_COCUCKA
                    </a>
                </h3>
                <div>
                    <span>Sponsored: </span>
                    <a
                        href='https://forum.vimeworld.ru/topic/735687-'
                        target='_blank'>
                        <img
                            alt='vtstyles'
                            style={{ width: '6rem', borderRadius: 6 }}
                            src={sponsored}
                        />
                    </a>
                </div>
            </Footer>
        </Layout>
    );
};

export default App;
